module.exports = __webpack_public_path__ + "img/E-601-640.f45eb9fd.svg";